/**
 * MoodSelector - Emoji-based mood selector
 */

import { motion } from 'framer-motion';
import { MOODS } from '../../stores/moodmapStore';

const MoodSelector = ({ selectedMood, onSelect }) => {
  return (
    <div className="flex items-center justify-center gap-3">
      {Object.entries(MOODS).map(([mood, config]) => {
        const isSelected = selectedMood === mood;

        return (
          <motion.button
            key={mood}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => onSelect(mood)}
            className={`
              relative w-14 h-14 rounded-xl text-3xl
              transition-all duration-200
              ${
                isSelected
                  ? `bg-${config.color}-500/30 border-2 border-${config.color}-500 shadow-lg shadow-${config.color}-500/20`
                  : 'bg-gray-800 border-2 border-transparent hover:bg-gray-700'
              }
            `}
            style={{
              backgroundColor: isSelected
                ? `var(--${config.color}-bg, rgba(16, 185, 129, 0.2))`
                : undefined,
              borderColor: isSelected
                ? getMoodBorderColor(config.color)
                : 'transparent',
            }}
          >
            <span className={isSelected ? '' : 'grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all'}>
              {config.emoji}
            </span>

            {/* Label */}
            <motion.span
              initial={{ opacity: 0, y: 5 }}
              animate={{ opacity: isSelected ? 1 : 0, y: isSelected ? 0 : 5 }}
              className="absolute -bottom-6 left-1/2 -translate-x-1/2 text-xs text-gray-400 whitespace-nowrap"
            >
              {config.label}
            </motion.span>

            {/* Selection indicator */}
            {isSelected && (
              <motion.div
                layoutId="mood-indicator"
                className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1.5 h-1.5 rounded-full"
                style={{ backgroundColor: getMoodBorderColor(config.color) }}
              />
            )}
          </motion.button>
        );
      })}
    </div>
  );
};

// Helper to get actual CSS color values
const getMoodBorderColor = (color) => {
  const colors = {
    emerald: '#10b981',
    green: '#22c55e',
    yellow: '#eab308',
    orange: '#f97316',
    red: '#ef4444',
  };
  return colors[color] || '#8b5cf6';
};

export default MoodSelector;
